import { Component, OnInit, Input } from '@angular/core';
import { ConteudoCaminho } from './conteudo-caminho';
import { AutenticacaoService } from 'src/app/autenticacao/autenticacao.service';
import { CabecalhoInfo, CabecalhoService } from './cabecalho.service';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';



@Component({
  selector: 'app-cabecalho-conteudo',
  templateUrl: './cabecalho-conteudo.component.html',
  styleUrls: ['./cabecalho-conteudo.component.less']
})
export class CabecalhoConteudoComponent implements OnInit {

  @Input()
  titulo: string = '';

  @Input()
  subtitulo: string = '';

  @Input()
  conteudoCaminho: ConteudoCaminho[] = [];

  @Input()
  conteudoId: string = '';

  constructor(private auth: AutenticacaoService, private cabecalhoService: CabecalhoService) { }

  ngOnInit() {
    this.cabecalhoService.$status
    .pipe(
      switchMap((info: CabecalhoInfo) => of(info))
    )
    .subscribe((info: CabecalhoInfo) => {
      this.titulo = info.titulo;
      this.subtitulo = info.subtitulo;
      this.conteudoCaminho = info.conteudoCaminho;
      this.conteudoId = info.conteudoId;
    });
  }

}
